import React from "react";
import founder from "../assets/founder.png"; // Make sure to use your actual photo

export default function AboutUs() {
  const sections = [
    {
      title: "About Vyango",
      text: `Vyango isn’t just a ride-sharing app — it’s a movement. We’re building a smarter, more connected way to travel across cities like Indore, Bhopal, Ujjain, and beyond. Whether you're a student, a commuter, or a weekend explorer, Vyango helps you share rides, cut costs, and meet people along the way.`,
      image: require("../assets/about.png"),
    },
    {
      title: "Our Mission",
      text: `We believe travel should be affordable, eco-conscious, and community-powered. Vyango reduces carbon emissions, makes intercity travel more accessible, and turns every journey into a chance to connect.`,
      image: require("../assets/mission.png"),
    },
    {
      title: "Our Services",
      text: `🚗 Post a Ride — Share your route and earn by filling empty seats.\n🔍 Find a Ride — Discover affordable rides posted by real people.\n💬 Chat Securely — Message drivers or passengers before you commit.\n🎯 Smart Filters — Search by city, date, vehicle type, and seat count.\n✅ Verified Profiles — Safety and trust built into every ride.`,
      image: require("../assets/services.png"),
    },
    {
      title: "How Vyango Helps You",
      text: `👩‍🎓 Students: Save money on weekend trips home.\n👨‍💼 Professionals: Commute between cities without the stress of driving.\n👨‍👩‍👧‍👦 Families: Travel together affordably and comfortably.\n🌍 Eco-warriors: Reduce your carbon footprint with every shared ride.`,
      image: require("../assets/use-cases.png"),
    },
    {
      title: "How It Works",
      text: `1. Search — Enter your route, date, and passenger count.\n2. Browse — View available rides with driver details and tags.\n3. Connect — Message the driver and confirm your seat.\n4. Ride — Meet up and travel together — simple, safe, and social.`,
      image: require("../assets/how-it-works.png"),
    },
    {
      title: "Why Vyango?",
      text: `💸 Cost-effective — Split fuel costs and save big.\n🌱 Eco-friendly — Fewer cars, cleaner air.\n🤝 Social — Meet new people and build connections.\n⚡ Fast & Easy — Post or find a ride in seconds.\n🔒 Safe — Verified users and secure communication.`,
      image: require("../assets/whytravelo.png"),
    },
  ];

  return (
    <div
      className="container"
      style={{
        marginTop: "40px",
        maxWidth: "1100px",
        marginLeft: "auto",
        marginRight: "auto",
        padding: "0 20px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Header Section */}
      <div style={{ textAlign: "center", marginBottom: "60px" }}>
        <h1
          style={{
            fontSize: "42px",
            fontWeight: "800",
            color: "var(--text, #111)",
            marginBottom: "16px",
            background: "linear-gradient(90deg, #00b4d8, #0077b6)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Redefining Intercity Travel
        </h1>
        <p style={{ fontSize: "18px", color: "var(--subtext, #555)", maxWidth: "600px", margin: "0 auto" }}>
          Discover the story, the mission, and the people behind the smarter way to commute.
        </p>
      </div>

      {/* Dynamic Sections */}
      {sections.map((section, index) => (
        <div
          key={index}
          className="card"
          style={{
            display: "flex",
            flexDirection: index % 2 === 0 ? "row" : "row-reverse",
            alignItems: "center",
            gap: "48px",
            marginBottom: "64px",
            padding: "40px",
            background: "var(--card-bg, #ffffff)",
            borderRadius: "24px",
            boxShadow: "0 12px 36px rgba(0, 0, 0, 0.06)",
            flexWrap: "wrap",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-5px)";
            e.currentTarget.style.boxShadow = "0 20px 40px rgba(0, 180, 216, 0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 12px 36px rgba(0, 0, 0, 0.06)";
          }}
        >
          {/* Text Section */}
          <div style={{ flex: 1, minWidth: "300px" }}>
            <h2
              style={{
                fontSize: "32px",
                fontWeight: "700",
                marginBottom: "20px",
                color: "var(--text, #222)",
              }}
            >
              {section.title}
            </h2>
            {section.text.includes("\n") ? (
              <ul style={{ paddingLeft: "0", listStyle: "none" }}>
                {section.text.split("\n").map((line, i) => (
                  <li
                    key={i}
                    style={{
                      fontSize: "17px",
                      color: "var(--subtext, #555)",
                      lineHeight: "1.8",
                      marginBottom: "12px",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p
                style={{
                  fontSize: "18px",
                  color: "var(--subtext, #555)",
                  lineHeight: "1.8",
                  letterSpacing: "0.2px",
                }}
              >
                {section.text}
              </p>
            )}
          </div>

          {/* Image Section */}
          <div style={{ flex: 1, minWidth: "300px", textAlign: "center" }}>
            <img
              src={section.image}
              alt={section.title}
              style={{
                width: "100%",
                maxWidth: "420px",
                borderRadius: "16px",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
      ))}

      {/* Founder Section */}
      <div
        className="card"
        style={{
          padding: "48px",
          marginTop: "80px",
          marginBottom: "64px",
          background: "linear-gradient(135deg, #f8fbff 0%, #e0f7fa 100%)",
          borderRadius: "24px",
          boxShadow: "0 12px 36px rgba(0, 0, 0, 0.06)",
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          alignItems: "center",
        }}
      >
        <div style={{ flex: "0 0 auto", margin: "0 auto" }}>
          <div
            style={{
              width: "180px",
              height: "180px",
              borderRadius: "50%",
              padding: "6px",
              background: "linear-gradient(45deg, #00b4d8, #0077b6)",
            }}
          >
            <img
              src={founder}
              alt="Rahul Gir"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover",
                border: "4px solid #fff",
              }}
            />
          </div>
        </div>
        
        <div style={{ flex: 1, minWidth: "300px", textAlign: "left" }}>
          <h2 style={{ fontSize: "14px", textTransform: "uppercase", letterSpacing: "2px", color: "#0077b6", fontWeight: "700", marginBottom: "8px" }}>
            Meet The Founder
          </h2>
          <h3 style={{ fontSize: "36px", color: "var(--text, #111)", marginBottom: "16px", fontWeight: "800" }}>
            Rahul Gir
          </h3>
          <p style={{ fontSize: "17px", color: "var(--subtext, #444)", lineHeight: "1.8" }}>
            The vision for Vyango started taking shape during Rahul's time studying computer science at the Mittal Institute of Technology in Bhopal. Recognizing the friction, costs, and environmental impact of standard intercity travel, he set out to build a platform that doesn't just move people, but connects them. As a full-stack developer and entrepreneur, Rahul is dedicated to making travel across India more affordable, eco-friendly, and completely community-driven.
          </p>
        </div>
      </div>

      {/* Tagline / Footer */}
      <div
        style={{
          textAlign: "center",
          padding: "60px 20px",
          borderTop: "2px solid #f0f0f0",
          marginTop: "20px",
        }}
      >
        <p style={{ fontSize: "28px", fontWeight: "800", color: "var(--text, #111)" }}>
          Vyango — Share rides. Save money. Travel better.
        </p>
        <p style={{ fontSize: "18px", color: "var(--subtext, #666)", marginTop: "12px" }}>
          Join the movement. Be part of the future of travel.
        </p>
      </div>
    </div>
  );
}